import { useEffect, useState } from 'react';
import { getAgeView, getHighJumpAgeView } from 'api/resultApi';

export const useAgeViewData = (params, isHighJump) => {
  const [state, setState] = useState({ data: null, loading: true, error: null });

  useEffect(() => {
    let cancelled = false;
    // Keep prior data visible while refetching — avoids full-page flash on
    // tab switches. Only loading=true is signalled.
    setState((prev) => ({ data: prev.data, loading: true, error: null }));

    const fetcher = isHighJump ? getHighJumpAgeView : getAgeView;
    fetcher(params)
      .then((data) => {
        if (cancelled) return;
        setState({ data, loading: false, error: null });
      })
      .catch((error) => {
        if (cancelled) return;
        setState({ data: null, loading: false, error });
      });

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    params.clubID,
    params.meetID,
    params.eventType,
    params.athleteAgeGroup,
    params.gender,
    params.roundType,
    isHighJump,
  ]);

  return state;
};
